export default {"src":"/_next/static/media/time.e519a67a.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};